import { h, Fragment, Component, Element, State } from '@stencil/core';
import type { ComponentInterface } from '@stencil/core';
import { breakpoints } from 'utils';

const fullWidth = breakpoints.lg.up;

@Component({
	tag: 'app-menu',
	styleUrl: 'menu-shadow.scss',
	shadow: true
})
export class Menu implements ComponentInterface {
	@Element() root: HTMLElement;

	@State() fullWidth: boolean;
	@State() openMobile = false;
	@State() openMenuLevel1s = new Set<HTMLAppDetailsElement>();

	close() {
		this.openMobile = false;
		this.root.querySelectorAll('app-details').forEach(details => {
			details.open = false;
		});
	}

	componentWillLoad() {
		const appDetailsElements = [...this.root.querySelectorAll('app-details')];
		const menuLevel1s = new Set(appDetailsElements.filter(
			details => details.name === 'menu-level-1' && 
			!details.classList.contains('menu__search')
		));
		const menuLevel2s = new Set(appDetailsElements.filter(details => details.name === 'menu-level-2'));

		const reflectWidth = () => {
			this.fullWidth = fullWidth.matches;

			menuLevel1s.forEach(details => {
				details.interestToggle = fullWidth.matches;
			});
			menuLevel2s.forEach(details => {
				details.forceShow =  (fullWidth.matches ? 'all' : undefined);
			});

			if (!fullWidth.matches && this.openMenuLevel1s.size)
				this.openMobile = true;
		};
		reflectWidth();
		fullWidth.addEventListener('change', reflectWidth);

		this.root.addEventListener('appDetailsToggled', async (e: CustomEvent<boolean>) => {
			const details = e.composedPath()[0] as HTMLAppDetailsElement;
			if (!menuLevel1s.has(details))
				return;

			const openMenuLevel1s = new Set(this.openMenuLevel1s);

			if (details.open)
				openMenuLevel1s.add(details);
			else
				openMenuLevel1s.delete(details);

			// account for vdom orphans
			for (const details of openMenuLevel1s)
				if (!details.isConnected)
					openMenuLevel1s.delete(details);

			this.openMenuLevel1s = openMenuLevel1s;
		});
	}

	render() {
		const isOpen = (!this.fullWidth && this.openMobile) || this.openMenuLevel1s.size > 0;
		return <>
			<app-overlay
				underNextSibling
				active={isOpen}
				onOverlayDismissed={() => {
					this.close();
				}}
			/>
			<div id='container' part='container'>
				{this.fullWidth
					?
						<>
							<div id='top-ribbon' part='top-ribbon'>
								<slot name='utilities' />
							</div>
							<div id='main-bar' part='main-bar'>
								<slot name='logo' />
								<slot name='menu' />
								<slot name='search' />
							</div>
						</>
					:
						<>
							<slot name='logo' />
							<app-details
								id='collapsable-menu'
								part='collapsable-menu'
								exportparts='content: collapsable-menu-content'
								open={isOpen}
								onAppDetailsToggled={e => {
									const appDetails = e.composedPath()[0] as HTMLAppDetailsElement;
									if (appDetails !== e.currentTarget)
										return;

									if (e.detail)
										this.openMobile = true;
									else
										this.close();
								}}
							>
								<div slot="open-icon">
									<app-icon icon='menu' />
									<span class="icon-text">Menu</span>
								</div>
								<div slot="close-icon">
									<app-icon icon='close' />
									<span class="icon-text">Close</span>
								</div>

								<slot name='utilities' />
								<slot name='search' />
								<slot name='menu' />
							</app-details>
						</>
				}
			</div>
		</>;
	}
}
